export class StorySettingEntity {
    constructor(init?: Partial<StorySettingEntity>) {
        Object.assign(this, init);
    }
}